import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { getCommercialIdentifier, ITransporterMember } from '../models/transporter-member.model';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { ApplicationConfigService } from './application-config.service';
import { createRequestOption } from '../app/shared/util/request-util';

export type EntityResponseType = HttpResponse<ITransporterMember>;
export type EntityArrayResponseType = HttpResponse<ITransporterMember[]>;

@Injectable({ providedIn: 'root' })
export class TransporterMemberService implements IBaryTableFetchService<ITransporterMember> {
  protected resourceUrl = API_ENDPOINTS.COMMERCIAL;

  constructor(protected http: HttpClient, protected apiProvider: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {}

  create(entity: ITransporterMember): Observable<EntityResponseType> {
    return this.apiProvider.post<ITransporterMember>(this.resourceUrl, entity);
  }

  update(commercial: ITransporterMember, newId: number | null): Observable<EntityResponseType> {
    const suffix = newId ? `/${newId}` : '';
    return this.apiProvider.put<ITransporterMember>(`${this.resourceUrl}/${getCommercialIdentifier(commercial)}${suffix}`, commercial);
  }

  find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<ITransporterMember>(`${this.resourceUrl}/${id}`);
  }

  // Get all transporter members that match a criteria
  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<ITransporterMember[]>(this.resourceUrl, options);
  }

  // Get all sales of the current transporter that match a criteria
  querySales(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<ITransporterMember[]>(`${this.resourceUrl}/sales`, options);
  }

  delete(id: number, newId?: number | null): Observable<HttpResponse<{}>> {
    const suffix = newId ? `/${newId}` : '';
    return this.apiProvider.delete(`${this.resourceUrl}/${id}${suffix}`);
  }

  fillDataToShow(entities: ITransporterMember[]): Observable<ITransporterMember[]> {
    return of(entities);
  }
}
